import { createContext, useContext, useEffect } from 'react'

type DiffPresence = {
  hasAnyDiff: boolean
  register: () => () => void
}

/**
 * Outside a popover that keeps count there is nothing to lay out, so nothing
 * asks and nothing answers.
 */
const noComparisons: DiffPresence = {
  hasAnyDiff: false,
  register: () => () => {},
}

export const DiffPresenceContext = createContext(noComparisons)

/**
 * Announces a comparison for as long as it is on show.
 */
export const useAnnounceDiff = () => {
  const { register } = useContext(DiffPresenceContext)

  useEffect(() => register(), [register])
}

/**
 * True while at least one comparison is on show in the popover.
 */
export const useHasAnyDiff = () => useContext(DiffPresenceContext).hasAnyDiff
